class StationsFormController {
  constructor(stateService, toasterService, CommonService, $uibModal) {
    'ngInject';
    this.stateService = stateService;
    this.toasterService = toasterService;
    this.CommonService = CommonService;
    this.$uibModal = $uibModal;
    this.getAudioSegment = this.CommonService.getAudioSegment;
    this.preLoadAudio = this.CommonService.preLoadAudio;
  }

  $onInit() {
    this.workspaceId = this.stateService.getSelectedWorkspace().id;
    this.station = angular.copy(this.selection);
    this.buildNeighboursList(this.station.neighbours, this.stations);
    this.stateService.getSegments().then(data => this.segments = data);
    this.audioSegment = this.getAudioSegment(this.station.segments);
    this.filteredFiles = this.preLoadAudio(this.audioSegment);
    this.viewMode = true;
    this.stationEdited = false;
    this.neighbourTooltip = "Add variables to neighbours by expanding a row";
  }

  toggleEditMode(value) {
    if (value) {
      this.viewMode = false;
    } else {
      // Reapply the current selection data if the user makes changes and presses 'Cancel'
      this.station = angular.copy(this.selection);
      this.buildNeighboursList(this.station.neighbours, this.stations);
      this.viewMode = true;
    }
  }

  buildNeighboursList(neighbours, stations) {
    neighbours.map(neighbour => neighbour.name = stations.find(({ id }) => id === neighbour.station).name);
  }

  onEditSegments(event) {
    this.stationEdited = true;
    this.station.segments = event.segments;
  }

  openVariableModal(neighbour) {
    let modalInstance = this.$uibModal.open({
      component: 'variableModal',
      backdrop: 'static',
      windowClass: 'subSystemWindow',
      resolve: {
        workspaceId: () => this.workspaceId
      },
    });

    modalInstance.result.then(
      variableObject => {
        // User pressed 'Yes' in the modal.
        this.stationEdited = true;
        if (neighbour) {
          neighbour.variables.push(variableObject);
        } else {
          this.station.variables.push(variableObject);
        }
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  }

  removeVariable(index) {
    this.station.variables.splice(index, 1);
    this.stationEdited = true;
  }

  removeNeighbourVariable(index, station) {
    station.variables.splice(index, 1);
    this.stationEdited = true;
  }

  onSubmit() {
    if (!this.stationEdited) {
      this.onFormSubmit({
        $event: {
          mode: false,
        },
      });
    } else {
      let updateObject = Object.assign({}, this.station);
      updateObject.add_stations = [];
      updateObject.add_neighbours = [];
      updateObject.neighbours.map(n => n.symmetric = false);
      updateObject.segments = updateObject.segments.map(s => {
        if (s.id) return {number: s.id}; 
        return {new_segment: s};
      });
      this.stateService.editStation(this.workspaceId, updateObject.id, updateObject).then(
        response => {
          this.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          this.toasterService.success('toaster.pis-event', 'toaster.pis-edit-station-successful');
        },
        err => {
          console.log(err);
        }
      );
    }
  }
}

angular
  .module('pis-tool.module')
  .controller('StationsFormController', StationsFormController);